export const variables = {
  fontWeight600: '600',
  fontWeight400: '400',
  fontSize32: '32px',
  fontSize28: '28px',
  fontSize24: '24px',
  fontSize20: '20px',
  fontSize18: '18px',
  fontSize16: '16px',
  fontSize14: '14px',
  fontSize12: '12px',
  fontSize10: '10px',

  lineHeight150per: '150%',
}

const size = {
  mobileMinimum: '390px',
  mobileMin: '576px',
  tablet: '768px',
  smallScreen: '1024px',
  largeScreen: '1440px',
}

export const device = {
  mobileMinimumMin: `(min-width: ${size.mobileMinimum})`,
  mobileMinimumMax: `(max-width: ${size.mobileMinimum})`,
  mobileMin: `(min-width: ${size.mobileMin})`,
  mobileMax: `(max-width: ${size.mobileMin})`,
  tabletMin: `(min-width: ${size.tablet})`,
  tabletMax: `(max-width: ${size.tablet})`,
  smallScreen: `(min-width: ${size.smallScreen})`,
  smallScreenMax: `(max-width: ${size.smallScreen})`,
  largeScreen: `(min-width: ${size.largeScreen})`,
}

const SHADOW_VALUE_LIGHT = '0px 0px 32px 0px rgba(51, 51, 51, 0.08)'
const SHADOW_VALUE_DARK = '0px 0px 32px 0px rgba(51, 51, 51, 0.30)'

export const themeColors = {
  light: {
    sidebarColor: {
      black: '#000000',
      blackGrey: '#1A1A1A',
      hoverGrey: '#262626',
      grey: '#A3A3A3',
      white: '#FFFFFF',
      brandGreen: '#06D960',
      darkGrey: '#333333',
      orange: '#E69D15',
    },
    color: {
      black: '#000000',
      hoverBlack: '#262626',
      darkGrey: '#333333',
      slateGrey: '#A3A3A3',
      mediumGrey: '#CACACA',
      lightGrey: '#E7E7E7',
      hoverWhite: '#F6F5F5',
      white: '#FFFFFF',
      pressedGreen: '#0B8E39',
      darkGreen: '#12A044',
      brandGreen: '#1CB954',
      lightGreen: '#D3F8E0',
      darkRed: '#A80C0C',
      mediumRed: '#EC1E1E',
      lightRed: '#FFDADA',
      darkOrange: '#B87D0C',
      mediumOrange: '#E69D15',
      lightOrange: '#FCECCF',
      progressBackground: '#F6F5F5',
      progressBackgroundValid: '#D3F8E0',
      progressValue: '#12A044',
    },
    unchangingColor: {
      white: '#FFFFFF',
      lightGrey: '#F6F5F5',
      black: '#000000',
      paypalBlue: '#0072C1',
      paypalBlueHover: '#005C9B',
    },
    shadow: {
      card: SHADOW_VALUE_LIGHT,
      header: SHADOW_VALUE_LIGHT,
      sidebar: SHADOW_VALUE_LIGHT,
      thumb: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    },
  },
  dark: {
    sidebarColor: {
      black: '#000000',
      blackGrey: '#1A1A1A',
      hoverGrey: '#262626',
      grey: '#A3A3A3',
      white: '#FFFFFF',
      brandGreen: '#06D960',
      darkGrey: '#333333',
      orange: '#E69D15',
    },
    color: {
      black: '#FFFFFF',
      hoverBlack: '#CACACA',
      darkGrey: '#FFFFFF',
      slateGrey: '#CACACA',
      mediumGrey: '#666666',
      lightGrey: '#333333',
      hoverWhite: '#262626',
      white: '#1A1A1A',
      pressedGreen: '#0D5928',
      darkGreen: '#D3F8E0',
      brandGreen: '#06D960',
      lightGreen: '#0D5928',
      darkRed: '#FFDADA',
      mediumRed: '#FF6262',
      lightRed: '#5E0808',
      darkOrange: '#FCECCF',
      mediumOrange: '#F9B941',
      lightOrange: '#5D4009',
      progressBackground: '#262626',
      progressBackgroundValid: '#0D5928',
      progressValue: '#D3F8E0',
    },
    unchangingColor: {
      white: '#FFFFFF',
      lightGrey: '#F6F5F5',
      black: '#000000',
      paypalBlue: '#0072C1',
      paypalBlueHover: '#005C9B',
    },
    shadow: {
      card: SHADOW_VALUE_DARK,
      header: SHADOW_VALUE_DARK,
      sidebar: SHADOW_VALUE_DARK,
      thumb: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    },
  },
}

export const MAX_TABLET_WIDTH = '1023px'
export const MAX_MOBILE_WIDTH = '767px'
